export const COLUMN_WIDTHS: Record<string, number> = {
  subject: 105,
  site: 100,
  sex: 100,
  age: 100,
  race: 100,

  randomization_status: 155,
  screen_status: 150,
  indication: 200,
  unscheduled: 150,
  DEFAULT: 130,
};

export const PROPEL_COLUMN_WIDTHS: Record<string, number> = {
  study_status: 230,
};

export const BB_HIDDEN_COLUMNS = new Set(["randomization_status"]);

export const DEFAULT_HIDDEN_COLUMNS = new Set(["indication", "participant_id"]);

export const NO_TIMEPOINT_COLUMNS = new Set([
  "subject",
  "participant_id",
  "site",
  "country",
  "screen_status",
  "randomization_status",
  "study_status",
]);

export const FIXED_COLUMNS = new Set([
  "subject",
  "participant_id",
  "site",
  "country",
]);

export const STATUS_COLUMNS = new Set([
  "screen_status",
  "randomization_status",
  "study_status",
]);

export const SEARCHABLE_COLUMNS = new Set([
  "subject",
  "site",
  "participant_id",
]);

export const STRING_NO_TIMEPOINT_COLUMNS = new Set([
  "subject",
  "country",
  "screen_status",
  "randomization_status",
  "study_status",
]);

export const NUMERIC_COLUMNS = new Set(["participant_id", "site", "age"]);

export const COLUMNS_WITH_LINK = new Set(["subject"]);

export const TITLE_MAPPING: Record<string, string> = {
  participant_id: "Participant ID",
  subject: "Subject ID",
  site: "Site ID",
  "Week 24/EOS": "Week 24/EOS",
  "EOT/ ET": "EOT/ ET",
};

export const INDEX_COLUMNS = new Set(["subject", "participant_id"]);

// Subject statuses that mean "never made it into the trial". The Visits & Activities
// grid pre-filters these out on load so it opens on enrolled subjects (active,
// completed, early terminated) instead of burying them under screen failures.
// Mirrors NON_ENROLLED_PARTICIPANT_STATUSES in the backend's views_trial_home.py,
// plus the screen-failure spellings VAStatusMapping already knows about.
export const NON_ENROLLED_STUDY_STATUSES = new Set([
  "Not Enrolled",
  "Screening",
  "Screened",
  "Screen Fail",
  "Screen Failed",
  "Screen Failure",
]);
